export const loadingBoxStyle = {
  paddingBottom: '$6',
  textAlign: 'center'
}
